// Copyright (c) MobiFactory. All rights reserved.
// This source code is the property of MobiFactory. It is exclusively available to customers who have a valid user license.
// See LICENSE.txt file in the project root for full license information.

import ElementPlus from "element-plus";
import "element-plus/theme-chalk/index.css";

import App from "./App.vue";
import { initRouter } from "./router";
import { createApp } from "vue";
import { useI18n } from "./plugins/i18n";
import { initTheme } from "./plugins/theme";

import oidcManager from "./authentication/oidcManager";
import appSettings from "./config/appSettings";
import buildOidcSettings from "./config/oidcSettings";
import { useOfficeState } from "./store/officeState";
import vueAppInsights from "./plugins/vueAppInsights";
import vuePermission from "./plugins/vuePermission";

Office.onReady(async () => {
  const settings = await appSettings.load();
  await oidcManager.init(buildOidcSettings(settings));

  // Manage mailbox item changed
  if (Office.context.mailbox) {
    const { refreshMailboxItem } = useOfficeState();
    Office.context.mailbox.addHandlerAsync(Office.EventType.ItemChanged, refreshMailboxItem);
    refreshMailboxItem();
  }

  // Reset local storage account id
  localStorage.setItem(appSettings.LAST_ACCOUNT_ID_STORAGE_KEY, "");

  // Vue App
  const app = createApp(App);
  const router = initRouter();
  app.use(router);
  app.use(ElementPlus);
  app.use(useI18n());
  app.use(vuePermission);

  app.config.globalProperties.$oidc = oidcManager;

  if (process.env.NODE_ENV !== "development") {
    app.use(vueAppInsights, {
      instrumentationKey: appSettings.APPINSIGHTS_INSTRUMENTATIONKEY,
      disableAjaxTracking: true,
      router,
    });
  }

  app.mount("#app");

  initTheme();
});
